import React from 'react';
import { Box, Spacer, Typography, Button, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ModalLocal, Link } from '@components';
import { modals } from '@modals';
import { rem } from '@helpers';
import { RoundIconWarning } from '@icons';
import { Anything } from '@types';
import { useExitModule } from './exitModule.helper';

export const ExitModule: React.FC = () => {
	const { palette } = useTheme();

	const { resources, onHandleRequestContact, onHandleContinue, onHandleLeave } = useExitModule();

	return (
		<ModalLocal
			name={modals.exitModule}
			contentCustomStyle={{
				padding: 32,
				width: rem(790),
			}}
			middleContent={{
				content: (
					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Box styles={{ width: rem(72), height: rem(72) }}>
							<RoundIconWarning exclamationColor={palette.global.ui18} />
						</Box>
						<Spacer vertical={24} />
						<Typography appearance="subtitle-200-02">{resources.title}</Typography>
						<Spacer vertical={4} />
						<Typography
							appearance="body-100-02"
							alternativeStyleProperties={{ color: palette.tertiary.t3 } as Anything}
						>
							{resources.subtitle}
						</Typography>
						<Spacer vertical={48} />
						<Button onPress={onHandleRequestContact}>{resources.requestContact}</Button>
						<Spacer vertical={24} />
						<Box styles={{ alignItems: 'center' }}>
							<Link onClick={onHandleContinue}>
								<Typography appearance="body-100-03" colorsLevel="linkDefault">
									{resources.continue}
								</Typography>
							</Link>
						</Box>
						<Spacer vertical={24} />
						<Box styles={{ alignItems: 'center' }}>
							<Link onClick={onHandleLeave}>
								<Typography appearance="body-100-03" colorsLevel="linkDefault">
									{resources.leave}
								</Typography>
							</Link>
						</Box>
					</Box>
				),
				type: 'custom',
			}}
		/>
	);
};
